"use client";

import { Workspace } from "@/db/schema";
import { SidebarHeader, SidebarMenuItem, SidebarMenu, SidebarMenuButton } from "../ui/sidebar";

import { OrganizationSwitcher } from "@daveyplate/better-auth-ui";
import { authClient } from "@/lib/auth-client";
import { OrganizationLogoImage } from "../ui/OrganizationLogoImage";

export function WorkspaceSidebarHeader({ workspace }: { workspace: Workspace }) {
  const { data: sessionData, isPending } = authClient.useSession();

  if (!isPending && !sessionData && workspace.imageId)
    return (
      <SidebarHeader>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton size="lg" asChild>
              <OrganizationLogoImage workspace={workspace} />
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarHeader>
    );

  return (
    <SidebarHeader>
      <SidebarMenu>
        <SidebarMenuItem>
          <SidebarMenuButton size="lg" asChild>
            <div className="w-full !px-0">
              <OrganizationSwitcher
                hidePersonal
                // The switcher's built-in create dialog would bypass
                // lib/createWorkspace (org without workspace row) — orgs are
                // created only via CreateOrganizationForm on /orgs.
                hideCreate
                slug={workspace.slug ?? undefined}
                variant="ghost"
                size="lg"
                className="w-full justify-start"
              />
            </div>
          </SidebarMenuButton>
        </SidebarMenuItem>
      </SidebarMenu>
    </SidebarHeader>
  );
}
